// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__ce4_r","errorLogs":"EditorFooter_errorLogs__5-wYd"};